import React from "react";
import { Column } from "@/shared/ui/Blocks";
import { Card } from "../Card";
import { SubtitleText } from "@/shared/ui/Typography";
import { upperFirst } from "lodash";

export interface HighlightedItemProps {
  label: string;
  description: string;
  HeaderComponent?: React.ReactNode;
  FooterComponent?: React.ReactNode;
  onClick?: () => void;
}

function HighightedItemCard(props: HighlightedItemProps) {
  const { label, description, HeaderComponent, FooterComponent, onClick } =
    props;

  return (
    <Card className="p-4 flex flex-1 overflow-visible" onClick={onClick}>
      <Column className="gap-2">
        {HeaderComponent}
        <h5>{upperFirst(label)}</h5>
        <SubtitleText size="small">{description}</SubtitleText>
        {FooterComponent}
      </Column>
    </Card>
  );
}

export { HighightedItemCard };
